import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/reset.css';
import './assets/common.css';

const isAxiosError = (object: unknown): object is AxiosError =>
  object !== null && typeof object === 'object' && 'isAxiosError' in object;

// Sentryにログ送信したい時は以下コメントアウトを外す
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  normalizeDepth: 10,
  maxBreadcrumbs: 100,
  tracesSampleRate: 1.0, // 1.0=100%=毎回トレース送信。本番では調整すべき
  beforeSend(event, hint) {
    const error: any = hint?.originalException;
    if (isAxiosError(error)) {
      const status = error.response?.status;
      if (status && status >= 400 && status < 500) {
        // 業務エラーは無視する
        return null;
      }
    }
    return event;
  },
});

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
